const React = require('react')
const { useParams, useHistory } = require('react-router-dom')
const { UncontrolledTooltip } = require('reactstrap')
const { useNetworkConfig } = require('@contexts')
const { LoadingSpinner, TransactionsTable } = require('@components')
const { TableHeader } = require('@components/table')

require('@styles/pages/address/transactions.address.css')

const AddressTransactions = props => {
    const { loading, data } = props
    const { address } = useParams()
    const history = useHistory()
    const { network } = useNetworkConfig()

    return (
        <div className='box table-section' style={{ paddingTop: !data?.transactions.totalItems ? 0 : undefined }}>
            {loading ? (
                <div className='d-flex justify-content-center align-items-center' style={{ height: '300px' }}>
                    <LoadingSpinner />
                </div>
            ) : (
                <>
                    {data?.transactions.totalItems > 0 && (
                        <TableHeader
                            title={
                                <>
                                    <span
                                        id='address-transactions-title'
                                        onClick={() => history.push(`/${network.name}/txs?a=${address}`)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        Latest&nbsp;
                                        {data?.transactions.totalItems > 25 ? '25' : data?.transactions.totalItems} from
                                        a total of&nbsp;
                                        <span className={`${network.name}-text-color`}>
                                            {data?.transactions.totalItems.toLocaleString()}
                                        </span>
                                        &nbsp; transaction{data?.transactions.totalItems > 1 ? 's' : ''}
                                    </span>
                                    <UncontrolledTooltip placement='top' target='address-transactions-title'>
                                        Click to view full list
                                    </UncontrolledTooltip>
                                </>
                            }
                            usePagination={false}
                        />
                    )}
                    <TransactionsTable data={data?.transactions.items} addressDisabled={address} />

                    {data?.transactions.totalItems > 25 && (
                        <div
                            className={`view-all ${network.name}-text-color-after`}
                            onClick={() => history.push(`/${network.name}/txs?a=${address}`)}
                        >
                            View all transactions
                            <i className='fas fa-arrow-right' />
                        </div>
                    )}
                </>
            )}
        </div>
    )
}

module.exports = { AddressTransactions }
